/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042108-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The field configurations for this connection configuration.  These define the form fields used by the connection configuration interface
 */
export interface ConfigFieldV1 {
    /**
     * Whether a null value is allowed
     */
    "allowNull": boolean;
    /**
     * Description of the field to be used in connection configuration interface
     */
    "description"?: string;
    /**
     * The name of the field.  It is set to the last component of the Path
     */
    "name"?: string;
    /**
     * JSON Path to the configuration parameter, omitting array indices
     */
    "path": string;
    /**
     * Field configuration type
     */
    "type": TypeEnum;
    /**
     * A key for this instance, unique among others in the tree. Useful for rendering.
     */
    "uniqueKey": string;
    /**
     * Configuration field value
     */
    "value"?: any;
}

export const TypeEnum = {
    SecretConfigFieldV1: 'SecretConfigFieldV1',
    StringConfigFieldV1: 'StringConfigFieldV1',
    DoubleConfigFieldV1: 'DoubleConfigFieldV1',
    LongConfigFieldV1: 'LongConfigFieldV1',
    BooleanConfigFieldV1: 'BooleanConfigFieldV1',
    RegexConfigFieldV1: 'RegexConfigFieldV1',
    DurationConfigFieldV1: 'DurationConfigFieldV1',
    ListConfigFieldV1: 'ListConfigFieldV1',
    EnumConfigFieldV1: 'EnumConfigFieldV1',
    ComplexObjectConfigFieldV1: 'ComplexObjectConfigFieldV1'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
